import React, { Dispatch, FC, SetStateAction, useCallback, useEffect, useRef } from 'react'
import { ExerciseInWorkout } from '@entities/exercise'
import { ExerciseDetailsScreen } from '@widgets/exercise/ExerciseDetailsView'
import '@pages/exerciseInfo/ui/exercise-info.css'

interface FullExerciseInfoProps {
	exercise: ExerciseInWorkout
	setIsShowingDescription: Dispatch<SetStateAction<boolean>>
}

export const FullExerciseInfoPage: FC<FullExerciseInfoProps> = ({
	exercise,
	setIsShowingDescription,
}) => {
	const hasDescriptionHistoryEntryRef = useRef(false)
	const exerciseDetails = {
		name: exercise.exercise_detail.name,
		description: exercise.exercise_detail.description,
		technique: exercise.exercise_detail.technique,
		muscle_group_codes: exercise.exercise_detail.muscle_group_codes,
		media: exercise.exercise_detail.media,
	}

	useEffect(() => {
		const currentState = window.history.state
		const nextState =
			typeof currentState === 'object' && currentState !== null
				? { ...currentState, workoutExecutionDescription: true }
				: { workoutExecutionDescription: true }

		window.history.pushState(
			nextState,
			'',
			`${window.location.pathname}${window.location.search}${window.location.hash}`
		)
		hasDescriptionHistoryEntryRef.current = true

		const handleHistoryBack = () => {
			hasDescriptionHistoryEntryRef.current = false
			setIsShowingDescription(false)
		}

		window.addEventListener('popstate', handleHistoryBack)

		return () => {
			window.removeEventListener('popstate', handleHistoryBack)
		}
	}, [setIsShowingDescription])

	const handleBack = useCallback(() => {
		if (hasDescriptionHistoryEntryRef.current) {
			window.history.back()
			return
		}

		setIsShowingDescription(false)
	}, [setIsShowingDescription])

	return (
		<ExerciseDetailsScreen
			exercise={exerciseDetails}
			onBack={handleBack}
		/>
	)
}
